const locale = {
	active: 'Active',
	inactive: 'Inactive',
	deleted: 'Deleted',
	filter:'Filter',
	filter_by: 'Filter by',
	reset_filters: 'Reset filters',
	project_name: 'Project Name',
	project_branch:'Project Branch',
	project_type:'Project Type',
	country:'Country',
	prefecture:'Prefecture',
	linked_members:'Linked Members',
	status:'Status',
	actions:'Actions',
	add_project: 'Add Project',
	companies: 'Companies',
	projects:'Projects',
	back_to_projects_list:' Back to projects list',
	all_projects: 'Projects',
	edit_projects: 'Edit Projects',
	search_project: 'Search project',
	search_member: 'Search member',
	create_project: 'Create project',
	edit_project: 'Edit Project',
	remove_project:'Remove Project',
	remove:'Remove',
	recover_project:'Recover Project',
	view_members:'View Members',
	do_you_want_to_remove_this_member:'Do you want to remove this Member ?',
	zip_code:'Zip Code',
	city:'City',
	town:'Town',
	latitude:'Latitude',
	longitude: 'Longitude',
	upload_map:'Upload Map',
	address: 'Address',
	drag_n_drop_some_files_here_or_click_to_select_files:'Drag and drop a file here, or click to select a file',
	please_enter_valid_url:'Please enter a valid URL',
	please_enter_valid_label:'Please enter no more than 15 characters',
	this_project_name_already_exist:'This project name already exist.',
	single_byte_numbers_no_hyphen:'Single-byte numbers / no hyphens required',
	please_enter_only_single_byte_numbers:'Please enter only single-byte numbers',
	do_you_want_to_remove_this_project: 'Do you want to remove this Project ?',
	do_you_want_to_recover_this_project: 'Do you want to recover this Project ?',
	invalid_address_please_try_again: 'Invalid address. Please try again.',
	created_succesfully: 'Created Succesfully',
	updated_succesfully: 'Updated Successfully',
	project_code: 'Project Code',
	only_alphanumeric_allowed:'Alphanumerical only',
	please_enter_a_valid_project_code: 'Please enter a valid Project Code',
	loading: 'Loading...',
	search: 'Search',

	current_project: 'Current Project:',
	mapping_member: 'Mapping Member',
	search_for_email: 'Search for an Email',
	submit: 'Submit',

	face_camera:'Face Camera URL',
};

export default locale;
